import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBazaarBadge2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={135}
    height={41}
    fill='none'
    {...props}
  >
    <path fill='url(#bazaar-badge2_svg__a)' d='M.455.017H135v40H.455z' />
    <defs>
      <pattern
        id='bazaar-badge2_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#bazaar-badge2_svg__b' transform='matrix(.00238 0 0 .008 0 0)' />
      </pattern>
      <image
        xlinkHref='/images/icons/bazaar-badge2-329b9ceb.webp'
        id='bazaar-badge2_svg__b'
        width={421}
        height={125}
      />
    </defs>
  </svg>
);
export default SvgBazaarBadge2;
